/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:59285187-d0c2-4263-8955-c707c3bdd8dd",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_nBPTZ6SSm",
    "aws_user_pools_web_client_id": "2lftttd99slauctdu0pm2aubmt",
    "oauth": {
        "domain": "alcangularapp-dev.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:4200/,https://doij6mj50jr3b.cloudfront.net/",
        "redirectSignOut": "http://localhost:4200/,https://doij6mj50jr3b.cloudfront.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
